"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageTableBase = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var copy_1 = require("../../copy");
var utils_1 = require("../../utils");
var UsageTable_styled_1 = require("./UsageTable.styled");
var utils_2 = require("./utils");
var DataCell = function (_a) {
    var data = _a.data, datePeriod = _a.datePeriod, fuel = _a.fuel, unit = _a.unit, disableLinks = _a.disableLinks, setDate = _a.setDate, rest = __rest(_a, ["data", "datePeriod", "fuel", "unit", "disableLinks", "setDate"]);
    var TextLink = (0, core_1.useComponents)().TextLink;
    var date = data.date;
    var formatted = (0, utils_2.formattedUsageForFuel)(data, fuel, unit);
    return (0, utils_1.hasDataForFuelOption)(data, fuel) && !disableLinks && date ? (react_1.default.createElement("span", __assign({}, rest),
        react_1.default.createElement(TextLink, { as: UsageTable_styled_1.StyledTableButton, "data-testid": "usage-table-link", onClick: function (e) {
                e.preventDefault();
                setDate(date, (0, utils_1.getRefinedDatePeriod)(datePeriod));
            } }, formatted))) : (react_1.default.createElement("span", __assign({}, rest), formatted));
};
var UsageTableBase = function (_a) {
    var data = _a.data, datePeriod = _a.datePeriod, fuel = _a.fuel, unit = _a.unit, disableLinks = _a.disableLinks, setDate = _a.setDate, date = _a.date, comparisonDate = _a.comparisonDate, comparisonType = _a.comparisonType, supplyInfo = _a.supplyInfo, rest = __rest(_a, ["data", "datePeriod", "fuel", "unit", "disableLinks", "setDate", "date", "comparisonDate", "comparisonType", "supplyInfo"]);
    var DataTable = (0, core_1.useComponents)().DataTable;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var isComparing = comparisonType !== 'noComparison' && !!comparisonDate;
    var unitLabel = unit === 'kwh' ? copy('tableUsageLabel') : copy('tableCostLabel');
    var periodLabel = datePeriod === 'yearly'
        ? copy('yearlyTablePeriodLabel')
        : datePeriod === 'monthly'
            ? copy('monthlyTablePeriodLabel')
            : copy('dailyTablePeriodLabel');
    var headings = isComparing
        ? [
            periodLabel,
            (0, utils_2.formatColDateForPeriod)(comparisonDate, datePeriod),
            (0, utils_2.formatColDateForPeriod)(date, datePeriod),
        ]
        : [periodLabel, unitLabel];
    var items = data
        .map(function (_a, key) {
        var date = _a.date, current = _a.current, comparison = _a.comparison;
        if (!isComparing &&
            (0, utils_2.dataOutsideSupply)(current.date, fuel, supplyInfo, datePeriod)) {
            return [];
        }
        var cells = [
            react_1.default.createElement("span", { key: "date-".concat(key), "data-testid": "usage-table-date" }, (0, utils_2.formatRowDateForPeriod)(date, datePeriod, isComparing)),
        ];
        if (isComparing && comparison) {
            cells.push(react_1.default.createElement(DataCell, { key: "comparison-data-".concat(key), "data-testid": "usage-table-comparison-data", data: comparison, datePeriod: datePeriod, fuel: fuel, unit: unit, disableLinks: disableLinks, setDate: setDate }));
        }
        cells.push(react_1.default.createElement(DataCell, { key: "data-".concat(key), "data-testid": "usage-table-data", data: current, datePeriod: datePeriod, fuel: fuel, unit: unit, disableLinks: disableLinks, setDate: setDate }));
        return cells;
    })
        .filter(function (i) { return i.length; });
    return (react_1.default.createElement(DataTable, __assign({ rowHeadings: true, "data-testid": "usage-table", columnHeadings: headings, items: items }, rest)));
};
exports.UsageTableBase = UsageTableBase;
